import React from "react";
import { ModalProps } from "./types";

const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  children,
  className = "",
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center p-4 bg-gray-500 bg-opacity-60 dark:bg-black dark:bg-opacity-65">
      <div
        className={`relative w-full bg-white dark:bg-black dark:text-white p-6 md:p-8 rounded-xl shadow-2xl ${className}`}
      >
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white text-3xl"
        >
          &times;
        </button>
        <div className="max-h-[90vh] overflow-y-auto pr-2">{children}</div>
      </div>
    </div>
  );
};

export default Modal;
